import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';
import { IManualEventOverrides } from '@faire/web/common/pete/types';

export const eventKey =
  'cart-abandoned_brand_cart_nudge_brand_info_clicked-click';

/**
 * User taps on brand info section in abandoned brand cart nudge on Web
 */
export function trackCartAbandonedBrandCartNudgeBrandInfoClickedClick(
  NudgeType_string: string,
  PageName_string2: string,
  manualOverrides?: IManualEventOverrides
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    manualOverrides,
    parameters: { NudgeType_string, PageName_string2 },
  });
}
